import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["video"];

  connect() {
    this.element.addEventListener("shown.bs.modal", this.play);
    this.element.addEventListener("hidden.bs.modal", this.pause);
  }

  disconnect() {
    this.element.removeEventListener("shown.bs.modal", this.play);
    this.element.removeEventListener("hidden.bs.modal", this.pause);
  }

  play = () => {
    this.videoTarget.play();
  };

  pause = () => {
    this.videoTarget.pause();
  };
}
